module.exports = __webpack_public_path__ + "static/media/confirm-logo.799ee3e7.svg";